/**
 * Shared StatCard Component
 *
 * Displays a metric with icon, title, and value.
 * Extracted from Dashboard.tsx for reuse across portal pages.
 */

interface StatCardProps {
  title: string;
  value: string;
  icon: React.ReactNode;
}

export function StatCard({ title, value, icon }: StatCardProps) {
  return (
    <div className="rounded-lg border border-brand-neutral-200 bg-surface p-4">
      <div className="flex items-center gap-3">
        <div className="rounded-md bg-brand-primary-50 p-2">
          <span className="text-brand-primary-600">{icon}</span>
        </div>
        <div>
          <p className="text-sm text-brand-neutral-500">{title}</p>
          <p className="text-2xl font-semibold text-brand-neutral-900">{value}</p>
        </div>
      </div>
    </div>
  );
}
